const { fetchJSON } = window.BAO.Utils

export class StoreSelector extends window.BAO.CustomElement() {
  _apiKey = 'cf4693569d1645be908f144882b8a666'

  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcherModal(countryCode)
      this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcherModal(countryCode)
      this.updateShippingLabel(countryCode)
    } else {
      fetchJSON(
        `https://api.ipgeolocation.io/ipgeo?apiKey=${this._apiKey}&fields=country_code2`,
        {
          method: 'GET',
        },
      ).then(res => {
        const countryCode = res.country_code2

        this.setupCountrySwitcherModal(countryCode)
        this.updateShippingLabel(countryCode)
      })
    }

    this.setupListeners()
  }

  forceRedirect () {
    fetchJSON(
      `https://api.ipgeolocation.io/ipgeo?apiKey=${this._apiKey}&fields=country_code2`,
      {
        method: 'GET',
      },
    ).then(res => {
      const userCountry = res.country_code2

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter(item => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.sites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}&currency=${
        this.countries[userCountry].currency
      }`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionClick = this.onOptionClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onBackdropClick = this.onBackdropClick.bind(this)

    if (this.els?.options.exists) {
      this.els.options.elements.forEach(optionEl => {
        this.listeners.add(optionEl, 'change', this.onOptionClick)
      })
    }

    if (this.els?.confirm.exists) {
      this.els.confirm.elements.forEach(confirmEl => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEL => {
        this.listeners.add(closeEL, 'click', this.onCloseClick)
      })
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    }

    if (this.els?.backdrop?.exists) {
      this.els.backdrop.elements.forEach(backdropEl => {
        this.listeners.add(backdropEl, 'click', this.onBackdropClick)
      })
    }

    /* Added due to trigger in mobile menu being rendered after page load */
    document.addEventListener('click', e => {
      if (e?.target?.dataset?.storeSelectorExternalEl === 'trigger') {
        this.onTriggerClick()
      }
    })
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  onTriggerClick () {
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  onOptionClick (e) {
    const selectedOptionValue = e.currentTarget.value
    const selectedOptionCode =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.code
    const selectedOptionCurrency =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.currency

    this.els.confirm.elements.forEach(confirmEl => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
      confirmEl.dataset.currency = selectedOptionCurrency
    })
  }

  onConfirmClick (event) {
    event.preventDefault()

    let windowPathname = window.location.pathname

    const subdomainFolder = windowPathname.split('/').filter(item => {
      return item.indexOf('en-') > -1
    })

    if (subdomainFolder) {
      windowPathname = windowPathname
        .replace(subdomainFolder, '')
        .replace('//', '/')
    }

    window.dataLayer.push({
      page_type: 'store_switcher',
      event: 'store_switcher',
      current_store: `${this.dataset.store}`,
      chosen_country: `${event.currentTarget.dataset.code}`,
    })

    if (
      this.countries[event.currentTarget.dataset.code].site ===
      this.dataset.store
    ) {
      window.localStorage.setItem(
        this.userLocationName,
        event.currentTarget.dataset.code,
      )

      this.els['localisation-select'].element.value =
        event.currentTarget.dataset.code
      this.els['localisation-select'].element.dispatchEvent(new Event('change'))
    } else if (event.currentTarget.hasAttribute('data-url')) {
      window.location.href = `${event.currentTarget.dataset.url}${windowPathname}?country=${event.currentTarget.dataset.code}&currency=${event.currentTarget.dataset.currency}`
    }
  }

  onCloseClick (event) {
    event.preventDefault()

    if (this.noLocationStored) {
      if (
        this.countries[event.currentTarget.dataset.code]?.site ===
        this.dataset.store
      ) {
        window.localStorage.setItem(this.userLocationName, this.dataset.store)
      }
    }

    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('util-SiteOverflowed')
  }

  onBackdropClick (event) {
    this.onCloseClick(event)
  }

  updateShippingLabel (countryCode) {
    if (this.noLocationStored) return

    const upperCountryCode = countryCode.toUpperCase()

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name
      const symbol = this.countries[upperCountryCode].symbol
      const currency = this.countries[upperCountryCode].currency

      /* Added due to trigger in mobile menu being rendered after page load */
      window.setTimeout(() => {
        document
          .querySelectorAll('[data-store-selector-external-el="label"]')
          .forEach(el => {
            el.innerHTML = `${symbol} ${currency}`
            el.dataset.content = `${symbol} ${currency}`
          })
      }, 1000)

      window.setTimeout(() => {
      document
        .querySelectorAll('[data-store-selector-external-el-footer="label"]')
        .forEach(el => {
          el.innerHTML = `${symbol} ${name}`
          el.dataset.content = `${symbol} ${name}`
        })
      }, 1000)
    }
  }

  setupCountrySwitcherModal (countryCode) {
    this.createOptionsList(countryCode)
    this.setDefaultConfirmButtonURL()

    if (
      this.countries[countryCode].site === this.dataset.store &&
      this.dataset.store === 'UK'
    ) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    if (!this.noLocationStored) {
      return
    }

    if (this.countryParam !== null) return

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  createOptionsList (countryCode) {
    const sortedCountries = Object.entries(this.countries).sort((a, b) =>
      a[1].name.localeCompare(b[1].name)
    )

    sortedCountries.forEach(([key, value]) => {
      const { name, site, currency, symbol } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.els.options.element.innerHTML += this.createOptionElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
        symbol,
      )
    })
  }

  createOptionElement (code, site, isCurrentSite, country, currency, symbol) {
    return `<option
      data-code="${code}"
      data-currency="${currency}"
      value="${site}"
      ${isCurrentSite ? 'selected' : ''}
    >
      ${country} (${symbol})
    </option>`
  }

  setDefaultConfirmButtonURL () {
    const selectedOptionValue = this.els.options.element.value
    const selectedOptionCode = this.els.options.element.options[
      this.els.options.element.selectedIndex
    ].dataset.code
    const selectedOptionCurrency = this.els.options.element.options[
      this.els.options.element.selectedIndex
    ].dataset.currency

    this.els.confirm.elements.forEach(confirmEl => {
      confirmEl.dataset.url = this.sites[selectedOptionValue].url
      confirmEl.dataset.code = selectedOptionCode
      confirmEl.dataset.currency = selectedOptionCurrency
    })
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !Shopify.designMode)
    )
  }

  get userLocationName () {
    return `BAO-localization`
  }

  get sites () {
    return {
      UK: {
        url: 'https://uk.tech21.com/',
        currency: '&currency=GBP',
      },
      EU: {
        url: 'https://eu.tech21.com/',
        currency: '&currency=EUR',
      },
      WWW: {
        url: 'https://www.tech21.com/',
        currency: '&currency=USD',
      },
      AU: {
        url: 'https://au.tech21.com/',
        currency: '&currency=AUD',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-selector')) {
  customElements.define('store-selector', StoreSelector)
}
